import React from 'react';

interface TitleSubcategoryProps {
    category: any;
    className: string;
}

const TitleSubcategory = ({
    category,
    className
}: TitleSubcategoryProps) => {
    return (
        <h3 className={`flex items-center gap-4 ${className}`}>
            <hr className='flex flex-1 opacity-50 border md:max-w-2' />
            <div className='flex flex-col gap-1'>
                <span className='text-base md:text-lg font-bold text-custom-primary text-nowrap text-center md:text-left'>{ category.name }</span>
                { category.description && <div className='flex w-full max-w-lg md:max-w-2xl text-sm md:text-base text-gray-400 text-center md:text-left italic leading-none md:leading-none'>{ category.description }</div>}
            </div>
            <hr className='flex flex-1 opacity-50 border' />
        </h3>
    );
};

export default TitleSubcategory;
